module.exports = __webpack_public_path__ + "img/weights2.bb53ae6e.png";